import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"

import { useAuth } from "@/hooks/useAuth"

import SignIn from "./SignIn"
import LoggedApp from "./LoggedApp"

// ----------------------------------------------------------------------------

export default function RoutedApp() {
  // Props destructuring

  // Hooks
  const { isAuthenticated } = useAuth()

  // Effects

  // Component functions

  // Component local variables
  let routedContent = null

  if (isAuthenticated) {
    routedContent = (
      <Routes>
        <Route path="/signin" element={<Navigate to="/" />} />
        <Route path="/*" element={<LoggedApp />} />
      </Routes>
    )
  } else {
    routedContent = (
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="*" element={<Navigate to="/signin" />} />
      </Routes>
    )
  }

  return <Router>{routedContent}</Router>
}
